import { IconLoader } from '@ui/src';
import { SheetTypes } from './types';
import Category from '../partial/reports/category';
import ReportHeader from '../partial/reports/header';
import formatReportBalance from '../../hoc/helpers/format-report-balance';

import ROUTES from '../../routes';

import cn from './safeguarding.module.css';

const Safeguarding = ({
  items,
  itemsVisible,
  excess,
  isLoading,
  search,
}: SheetTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <div className={cn.safeguardingList}>
        {items?.map((item) => (
          <Category
            itemsVisible={itemsVisible}
            category={item}
            search={search}
            key={item.id}
            fromPath={ROUTES.REPORTS_SAFEGUARDING}
            type="safeguarding"
          />
        ))}
      </div>
    );
  }

  return (
    <div className={cn.safeguardingContent}>
      <ReportHeader />
      {content}
      <div
        className={`${cn.checksum} ${
          excess && excess < 0 ? cn.checksumRed : ''
        }`}
      >
        <div className={cn.checksumTitle}>
          {excess && excess < 0 ? 'Shortage' : 'Excess'}
          <div
            className={cn.safeguardingHint}
            data-text={
              excess && excess < 0
                ? 'can move funds from safeguarding bank account to own funds bank account'
                : 'You should remove excess fund from safeguarding account(s) to own funds account(s) via nostro transaction'
            }
          >
            i
          </div>
        </div>
        <div>{formatReportBalance(Number(Math.abs(excess || 0) || 0))}</div>
      </div>
    </div>
  );
};

export default Safeguarding;
